import { MdOutlineReportProblem } from "react-icons/md";

export default function Footer() {
  return (
    <footer className="bg-blue-900 text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-6 flex flex-col items-center gap-2">
        {/* Premier texte */}
        <div className="text-sm text-gray-300 text-center">
          © 2026 Tradie Time — MVP v1.0
        </div>

        {/* Lien avec icône */}
        <div>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSdgh9wDY6KG5peKcRKVI0cYmxeNXY4fc-IxyHhg-dthA5A8nA/viewform"
            target="_blank"
            rel="noopener noreferrer"
            className="text-yellow-500 hover:text-yellow-400 text-sm flex items-center gap-1"
          >
            Found an issue <MdOutlineReportProblem className="text-lg" />? Let us know!
          </a>
        </div>
      </div>
    </footer>
  );
}
